import { Box } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import TabsGeneral from 'src/components/Tabs'
import useLayoutContext from 'src/hooks/useAuthLayout'
import ListaFamiliares from './lista'
import RegisterFamiliar from './register'

export default function RegistrarFamilair() {
    const {modalOpen} = useLayoutContext()
    const [familiares,setFamiliares] = useState([])
    const getDatos =async(dni)=>{
        const rpta = await axios.get(`https://apis-anterior.vesaliohce.com.pe/getFamilairesCita/${dni}`)
        setFamiliares(rpta.data)
    }
    const [tabs, setTabs] = useState([{ value: '01', label: 'Lista', active: true }, { value: '02', label: 'Registrar', active: false }])

    useEffect(()=>{
        getDatos(modalOpen.item.selected.paciente.item.Nro_DocIdenti);
    },[modalOpen])
  return (
    <>
        <Box sx={{ pl: 2 }}>
            <TabsGeneral setTabs={setTabs} tabs={tabs} />
        </Box>
        {
            tabs.find(x=>x.active).value === '01' && <ListaFamiliares familiares={familiares}/>
        }
        {
            tabs.find(x=>x.active).value === '02' && <RegisterFamiliar getDatos={getDatos}/>
        }
    </>
  )
}
